import type {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {Button, Icon, IconNames} from '@wellstone-solutions/web';
import {LD_FLAGS, useFeatureFlag} from 'modules/feature-flags';

interface EditResourceButtonProps {
  resourceId: string;
  onNavigate?: () => void;
}

export const EditResourceButton: FC<EditResourceButtonProps> = ({
  resourceId,
  onNavigate,
}) => {
  const navigate = useNavigate();
  const canManageResources = useFeatureFlag(LD_FLAGS.RESOURCE_ADMIN);

  if (!canManageResources) {
    return null;
  }

  return (
    <Button
      data-testid="edit-resource-button"
      onClick={() => {
        onNavigate?.();
        navigate(`/resources/${resourceId}/edit`);
      }}
      sx={styles.button}
      startIcon={
        <Icon name={IconNames.EditPencil} size={16} color="primary" />
      }>
      Edit
    </Button>
  );
};

const styles = {
  button: {
    textTransform: 'none',
    '& .MuiButton-startIcon': {
      marginRight: 0.75,
      marginLeft: 0,
    },
  },
};
